import { getCodeSetLabelLookup } from '../../../Functions/CodeSetFns'
import { Stack } from '@mui/material'
import * as React from 'react'
import { tsScreenCollection } from '../../../Typescript/DB_Interface'
import { useUserContext } from '../../../Contexts/UserConfig'
import { ReadOnlyTextField } from '../../../garvan-react/Components/ReadOnlyTextField'
import { stackGap } from '../../../Constants&Theme/Spacing'

function ScreenCollectionDetails({
  collection,
}: {
  collection: tsScreenCollection
}) {
  //TODO:  Merge with CollectionCard
  const { loginConfig } = useUserContext()
  return (
    <Stack
      aria-label={'Screen Collection Details'}
      gap={stackGap.col}
      width={1}
    >
      <Stack
        direction={'row'}
        gap={stackGap.row}
        width={1}
      >
        <ReadOnlyTextField
          label="Sample Type"
          value={getCodeSetLabelLookup(
            loginConfig,
            ['SampleRunTypeID'],
            collection?.SampleType,
          )}
          fullWidth
        />
        <ReadOnlyTextField
          label="Destination Lab"
          value={getCodeSetLabelLookup(
            loginConfig,
            ['KV-Facilities'],
            collection?.DestinationFacilityID,
          )}
          fullWidth
        />

        <ReadOnlyTextField
          label="Collection Status"
          value={getCodeSetLabelLookup(
            loginConfig,
            ['ScreenCollectionStatusID'],
            collection?.CollectionStatus,
          )}
          fullWidth
        />
      </Stack>
      <Stack
        direction={'row'}
        gap={stackGap.row}
        width={1}
      >
        <ReadOnlyTextField
          label="Criteria"
          value={getCodeSetLabelLookup(
            loginConfig,
            ['ScreenCriteriaID'],
            collection?.Criteria,
          )}
          fullWidth
          sx={{ flex: 1 }}
        />
        <ReadOnlyTextField
          label="Criteria Details"
          value={collection?.CriteriaDetails || ''}
          fullWidth
          sx={{ flex: 2 }}
        />
      </Stack>
      <ReadOnlyTextField
        label="Tests"
        value={collection?.Tests || ''}
        fullWidth
      />
      <ReadOnlyTextField
        label="Collection Instructions"
        value={collection?.CollectionInstructions || ''}
        fullWidth
      />
    </Stack>
  )
}

export default ScreenCollectionDetails
